import React from 'react';
import './Home.css';
function Projects() {
  return (
    <section id="projects">
      <h2>Projects </h2>
      <ul>
        <p>During my academic journey, I have worked on several projects that demonstrate my ability to apply theoretical knowledge to practical scenarios:</p>
        <li><a href="https://github.com/username/project1">Project 1:</a>
        <p>&nbsp; A web application that developed using HTML,CSS,Java Script like a e-commerce website as Men's Store.</p></li>
        <li><a href="https://github.com/username/project2">Project 2:</a>
        <p>&nbsp;An algorithmic solution that reduced time to train a model and increased accuracy by combining both deep learning algorithms as one model by a team in Bachelors.The title is Human  Suspecious Activity Detection Using Video Surveillance.</p></li>
      </ul>
    </section>
  );
}

export default Projects;
